var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
import { TAG_MIDDLE_NAME } from '../constants';
import { KnownShader, MaterialElement } from './material';
//namespace Pacem.Components.Drawing3D {
let PhongMaterialElement = class PhongMaterialElement extends MaterialElement {
    constructor() {
        super(KnownShader.Phong);
    }
    async createMaterial() {
        return Utils.extend({
            emissiveColor: this.emissiveColor || '#000',
            reflectivity: this.reflectivity ?? 0,
            refractionRatio: this.refractionRatio ?? 0,
            specularColor: this.specularColor || '#000',
            shininess: this.shininess ?? 0,
            flatShading: this.flatShading ?? true
        }, await super.createMaterial());
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'emissiveColor':
                case 'reflectivity':
                case 'refractionRatio':
                case 'specularColor':
                case 'shininess':
                case 'flatShading':
                    this.updateMaterial();
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PhongMaterialElement.prototype, "emissiveColor", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PhongMaterialElement.prototype, "reflectivity", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PhongMaterialElement.prototype, "refractionRatio", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PhongMaterialElement.prototype, "specularColor", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PhongMaterialElement.prototype, "shininess", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PhongMaterialElement.prototype, "flatShading", void 0);
PhongMaterialElement = __decorate([
    CustomElement({ tagName: `${P}-${TAG_MIDDLE_NAME}-material-phong` })
], PhongMaterialElement);
export { PhongMaterialElement };
